<!--
 * @Descripttion: 申请样品业务组件，支持快速申样及批量申样
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-10-10 14:15:33
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-04 11:31:35
-->
<template>
	<div>
		<el-drawer title="添加商品" :visible.sync="visible" class="add-goods" :before-close="handleClose" size="700px" :wrapperClosable="false">
			<!-- 抽屉内容 -->
			<div class="content">
				<div class="flex flex-align-center">
					<SelectTag
						ref="selectTag"
						placeholder="请选择商品标签"
						:collapseTags="true"
						:multiple="true"
						v-model="tagIds"
						@change="getList"
						style="width: 240px"
					></SelectTag>
					<div class="filter-box pos-rela ml-16" style="height: auto">
						<el-input style="width: 400px; margin-right: 10px" placeholder="请输入" v-model="searchValue">
							<el-select v-model="selectOption" slot="prepend" placeholder="请选择" @change="changeSelect">
								<el-option :label="item.label" :value="item.value" v-for="item in dropdownList" :key="item.value"></el-option>
							</el-select>
						</el-input>
						<el-button class="searchBtn" @click="search()">搜索</el-button>
					</div>
				</div>
				<el-table ref="table" :data="tableData" style="width: 100%" v-loading="tableLoading" row-key="product_id" @row-click="rowClick">
					<el-table-column label="商品信息">
						<template slot-scope="{ row }">
							<div class="flex flex-align-center">
								<el-radio v-model="productId" :label="row.product_id">{{ '' }}</el-radio>
								<goodsBox :row="row" :platformId="row.platform_id"></goodsBox>
							</div>
						</template>
					</el-table-column>
					<el-table-column width="100" label="现售价">
						<template slot-scope="{ row }">
							<div class="flex flex-align-center yx-color-pure-1 font-h4-regular">
								{{ row.sale_price | formatEmpty | formatPrice }}
							</div>
						</template>
					</el-table-column>
					<el-table-column label="商品标签" width="180">
						<template slot-scope="{ row }">
							<div class="flex flex-align-center">
								<goods-tag-cell :row="row" ref="goodsTagCell" auth="system:shopLibray:addTag" :editTag="false" />
							</div>
						</template>
					</el-table-column>
				</el-table>
				<yx-pagination
					:total="total"
					:current-page="pageInfo.page_index"
					:page-size="pageInfo.page_size"
					@size-change="sizeChange"
					@current-change="currentChange"
				></yx-pagination>
			</div>
			<!-- 底部按钮组 -->
			<div class="footer flex flex-align-center flex-just-end">
				<div>
					<el-button @click="handleClose">取消</el-button>
					<el-button type="primary" @click="confirm" :disabled="isDisable" :loading="loading">确认添加</el-button>
				</div>
			</div>
		</el-drawer>
	</div>
</template>
<script>
import SelectTag from '@/components/business/tagDialog/selectTag';
import goodsBox from '@/components/ui/goodsBox';
import goodsTagCell from '@/components/tableCells/goodsTagCell.vue';
import { productList } from '@/api/shopManage';
export default {
	name: 'addGoods',
	props: {
		platformId: {
			type: [String, Number],
			default: 1,
		},
	},
	components: {
		SelectTag,
		goodsTagCell,
		goodsBox,
	},
	data() {
		return {
			visible: false, // 抽屉显隐
			loading: false,
			tableData: [],
			tagIds: '',
			borderColor: '#e2e3e8',
			dropdownList: [
				{
					value: 0,
					label: '商品名称',
					key: 'product_name',
				},
				{
					value: 1,
					label: '商品id',
					key: 'third_product_id',
				},
			],
			selectOption: 0,
			searchValue: '',
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 100,
			},
			tableLoading: false,
			productId: 0,
			index: 0,
		};
	},
	computed: {
		isDisable({ productId }) {
			return !productId;
		},
	},
	methods: {
		show(productId, index = 0) {
			this.index = index; //回填数组
			this.productId = productId;
			this.getList();
			this.visible = true;
		},
		async getList() {
			const { platformId, selectOption, searchValue, tagIds: tag_ids } = this;
			this.tableLoading = true;
			let key = this.dropdownList.find(item => item.value === selectOption).key;
			let params = { [key]: searchValue };
			try {
				const {
					list = [],
					page: { item_total = 0 },
				} = await productList({ ...this.pageInfo, tag_ids, ...params, platform_id: platformId });
				this.total = item_total;
				this.tableData = list;
				this.tableLoading = false;
			} catch (e) {
				this.tableLoading = false;
			}
		},
		confirm() {
			const data = this.tableData.find(item => item.product_id === this.productId);
			const { product_id, product_name } = data;
			this.$emit('confirmAddGoods', { product_id, product_name }, this.index);
			this.handleClose();
		},
		changeSelect(e) {
			this.searchValue = '';
		},
		sizeChange(val) {
			this.pageInfo.page_size = val;
			this.getList();
		},
		currentChange(val) {
			this.pageInfo.page_index = val;
			this.getList();
		},
		search() {
			this.getList();
		},
		handleClose() {
			this.tableData = [];
			this.tagIds = '';
			this.index = 0;
			this.searchValue = '';
			this.selectOption = 0;
			this.pageInfo = {
				page_index: 1,
				page_size: 100,
			};
			this.$refs.selectTag.reset();
			this.visible = false;
		},
		rowClick({ product_id }) {
			this.productId = product_id;
		},
	},
};
</script>
<style lang="less" scoped>
.add-goods {
	.content {
		padding: 24px 24px 60px 24px;
	}
	.filter-box {
		.el-select {
			width: 100px;
		}
		/deep/ .el-input-group__prepend {
			background-color: #fff;
			border: 1px solid #e2e3e8;
			border-right: none;
			border-top-left-radius: 4px;
			border-bottom-left-radius: 4px;
		}
	}
	.searchBtn {
		width: 56px;
		background-color: @color-primary;
		color: #ffffff;
		font-size: 13px;
		border-top-left-radius: 2px;
		border-bottom-left-radius: 2px;
		position: absolute;
		right: 0;
		top: 0px;
		border: 1px solid @color-primary;
	}
	.shop-tag {
		height: 18px;
		line-height: 18px;
		border-radius: 2px;
		text-align: center;
		font-size: 12px;
		margin-top: 4px;
		background-color: #f7f8fa;
		display: inline-block;
		padding: 0px 3px;
		img {
			width: 12px;
			height: 11px;
			margin-bottom: 2px;
			margin-right: 3px;
		}
	}
	.tag {
		display: grid;
		grid-template-columns: 1fr 1fr;
		grid-gap: 12px 16px;
		.item {
			width: 220px;
			padding: 6px 8px;
			.title {
				width: 140px;
				padding: 2px 8px;
			}
		}
	}
	.footer {
		position: absolute;
		width: 100%;
		bottom: 0;
		padding: 10px;
		border-top: 1px solid #f0f1f5;
		background-color: #fff;
		box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
		z-index: 999;
	}
	::v-deep .el-radio {
		margin-right: 10px;
	}
}
</style>
